import { Select, SelectProps } from "o4a-react";
import * as React from "react";
import { VmdbDbSystemOptionsStorageManagementEnum } from "../../gen/clients/mchub-azure-api-client-vmdb";

export interface StorageSizeProps extends Omit<SelectProps, "options"> {
  storageType?: VmdbDbSystemOptionsStorageManagementEnum;
}

const StorageSizeListASM: number[] = [256, 512, 1024, 2048, 4096, 6144, 8192, 10240, 12288, 14336, 16384, 18432,
  // tslint:disable-next-line:align
  20480, 22528, 24576, 26624, 28672, 30720, 32768, 34816, 36864, 38912, 40960];

// TODO: temporary until listDbSystemStorageDisks API made available
const StorageSizeListLVM: number[] = [256, 512, 1024, 2048, 4096, 6144, 8192];

export const StorageSizeSelect = ({
  defaultValue,
  storageType = "ASM",
  disabled,
  fieldName,
  label,
  onChange,
  placeholder,
  required,
  tooltip,
  validator,
  testId,
}: StorageSizeProps): JSX.Element => {
  // scale down is not supported for vmdb so only include sizes that are greater than or equal to current value
  const currentValue = defaultValue && defaultValue[0] ? Number(defaultValue[0]) : 0;
  const storageListOptionsASM = StorageSizeListASM.filter(size => size >= currentValue).map(size => ({
    id: size.toString(),
    text: size.toString(),
  }));

  const storageListOptionsLVM = StorageSizeListLVM.filter(size => size >= currentValue).map(size => ({
    id: size.toString(),
    text: size.toString(),
  }));

  return (
    <Select
      label={label}
      testId={testId}
      tooltip={tooltip}
      required={required}
      disabled={disabled}
      onChange={onChange}
      fieldName={fieldName}
      placeholder={placeholder}
      defaultValue={defaultValue}
      options={storageType === "LVM" ? storageListOptionsLVM : storageListOptionsASM}
      validator={validator}
      hideSearchBox
    />
  );
};
